import { Card } from 'components/Card';
import { Card as CardType, ListStyle } from '@yleisradio/areena-types';
import { useProgress } from 'hooks/useProgress';
import React from 'react';
import { getHistoryLabelsForCard } from 'utils/card';
import { PlaceholderCard } from 'components/PlaceholderCard';
import { useFetchQueueCard } from 'components/Player/AudioPlayerWrapper/useFetchQueueCard';
import { SimpleCard } from './SimpleCard/SimpleCard';
import { useFeatureFlag } from 'contexts/FeatureFlagContext';

type Props = {
  itemId?: string;
  index: number;
  cardKey: string;
  isActive: boolean;
  isSimpleCard?: boolean;
  handleCheckboxChange: (
    event: React.ChangeEvent<HTMLInputElement>,
    index: number
  ) => void;
  selectedCardIndexes: number[];
};

const sizes =
  '(min-width: 1920px) 18vw, (min-width: 1020px) 17vw, (min-width: 640px) 21vw, 35vw';

const listStyle: ListStyle = {
  layout: 'vertical',
  image: '1:1',
  size: 'medium',
};

type QueueCardProps = {
  cardKey: string;
  isActive: boolean;
  card: CardType;
};

const QueueCard = ({ card, cardKey, isActive }: QueueCardProps) => {
  const { historyEntries } = useProgress([card]);
  const historyLabels = getHistoryLabelsForCard(card, historyEntries);
  const { playQueue2024 } = useFeatureFlag();
  return (
    <Card
      card={card}
      cardKey={cardKey}
      sizes={sizes}
      listStyle={listStyle}
      historyLabels={historyLabels}
      isActive={isActive}
      isDescriptionVisible={playQueue2024}
      hasEpisodeTitle={true}
    />
  );
};

const PlayQueueCard = ({
  itemId,
  index,
  cardKey,
  isActive = false,
  isSimpleCard,
  handleCheckboxChange,
  selectedCardIndexes,
}: Props) => {
  const cardByItemId = useFetchQueueCard(itemId);
  if (!cardByItemId && itemId) {
    return <PlaceholderCard listStyle={listStyle} />;
  }
  if (!cardByItemId) return null;

  if (isSimpleCard) {
    return (
      <SimpleCard
        index={index}
        card={cardByItemId}
        selectedCardIndexes={selectedCardIndexes}
        handleCheckboxChange={handleCheckboxChange}
        cardKey={cardKey}
      />
    );
  }
  return (
    <QueueCard card={cardByItemId} cardKey={cardKey} isActive={isActive} />
  );
};

export { PlayQueueCard, QueueCard };
